import { render, staticRenderFns } from "./AufgabeBoardItem.vue?vue&type=template&id=35c9fb6b&scoped=true"
import script from "./AufgabeBoardItem.vue?vue&type=script&lang=ts"
export * from "./AufgabeBoardItem.vue?vue&type=script&lang=ts"
import style0 from "./AufgabeBoardItem.vue?vue&type=style&index=0&id=35c9fb6b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9fb6b",
  null
  
)

export default component.exports